<div>
  <b>
    <a [routerLink]="['/kundorder', sourceAggregat.kundorderId]" [ngbTooltip]="getFullKundNamn()" container="body">
      {{getShortKundNamn()}}
    </a>
  </b>
</div>
<div>{{sourceAggregat.mottagningsplats.namn}}</div>
<div>{{sourceAggregat.handelssortiment.namn}} {{sourceAggregat.mattslag}}</div>
@if (sourceAggregat.kommentar?.length) {
  <rask-icon-button
    class="kundorderrad-comment"
    (click)="openComment()"
    icon="fa-solid fa-comment">
  </rask-icon-button>
}
